import React from 'react';
import '../styles/roboticsProduct.css'
import AnimationBox from '../animationBox';
import AnimatedArrowButton from './AnimatedArrowButton';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import product1 from '../assets/product1.png';
import product2 from '../assets/product2.png';
import product3 from '../assets/product3.png';
import product4 from '../assets/product4.png';


const RoboticsProducts= () => {

    const sliderSettings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

    const cards = [
        { name: 'ARC Mate 100 iD', company: "By FANUC" , image:product1  , axes:"6" , payload:'12 Kg' , reach:'1441 mm'},
        { name: 'LR Mate 200 iD', company: "By FANUC" , image:product2  , axes:"6" , payload:'7 Kg' , reach:'717 mm'},
        { name: 'R-2000iC/125L', company: "By FANUC" , image:product3 , axes:"6" , payload:'125 Kg' , reach:'3100 mm'},
        { name: 'SACARA SR-3iA', company: "By FANUC" , image:product4  , axes:"4" , payload:'3' , reach:'400'}, 
        
      ];

    return(<div className='roboticsproduct'>

        <AnimationBox>
            <div className='roboticsproduct-inner' >
            <div className='myservices' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838',gap:'10px'}}>
                        
                        <h4 style={{color:'#FFD52B'}}>Featured Products</h4>
                        
            </div>
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"25px"}}>
                        
                        <div className='services-msg' style={{textAlign:'left'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between'}}><h1 style={{fontWeight:"600"}}>Explore Our Cutting-Edge<br></br> Robotics Solutions</h1> <div className='button1'> <AnimatedArrowButton  text="Learn More" link="/Robotics-Products"   /></div> </div>
                            <p style={{color:'white', fontSize:"14px"}}>Discover our top-selling robots, designed to meet the diverse needs of industries worldwide. From precision handling to smart automation, we have the perfect solution for your business.</p>
                            <div className='button2'> <AnimatedArrowButton  text="Learn More" link="/Robotics-Products"   /></div> 
                        </div>
            </div>
            <div style={{  maxWidth: "1000px", margin: "auto" }}>
      <Slider {...sliderSettings}>
        {cards.map((card) => (
          <div key={card.id} style={{ padding: "10px"}}>
            <div
              style={{
                height: "22rem",
                backgroundColor: "#0C0A00",
                border:'1px solid #383838',
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                borderRadius: "10px",
                marginLeft:"10px",
                marginRight:"10px",
                padding:'1rem',
                flexDirection:'column',
                textAlign:'left'
              }}
              className='product-card'
            >
              <div style={{height:'50%',width:'100%', overflow:'hidden'}}>
                <img src={card.image} style={{objectFit:'contain',width:'100%', height:'100%'}}></img>
                

              </div>
              <h5 style={{width:'100%',marginTop:'1rem'}}>{card.name}</h5>
            <p style={{width:'100%', fontSize:'0.7rem', color:'white', borderBottom:"1px solid #2F2F2F" ,paddingBottom:'0.7rem',marginBottom:'0.3rem'}}>{card.company}</p>
            <div style={{display:'flex', justifyContent:'space-between' , alignItems:'start', width:'100%' , paddingBottom:'0.1rem', borderBottom:"1px solid #2F2F2F",color:"#FFFFFF",fontSize:'0.8rem'}}><p>Axes</p><p>{card.axes}</p></div>
            <div style={{display:'flex', justifyContent:'space-between' , alignItems:'start', width:'100%' , paddingBottom:'0.1rem', borderBottom:"1px solid #2F2F2F",color:"#FFFFFF",fontSize:'0.8rem'}}><p>Payload</p><p>{card.payload}</p></div>
            <div style={{display:'flex', justifyContent:'space-between' , alignItems:'start', width:'100%' , paddingBottom:'0.1rem', color:"#FFFFFF",fontSize:'0.8rem'}}><p>Reach</p><p>{card.reach}</p></div>

            </div>
            
          </div>
        ))}
      </Slider>
    </div>
            

            </div>
        </AnimationBox>
    

    </div>);

}

export default RoboticsProducts;